<app-header title="Form Details"></app-header>

<ion-content>
  <ion-grid fixed class="ion-padding-horizontal">
   
  </ion-grid>
</ion-content>
